<script setup lang="ts">
import AuditCalendar from '@/modules/audits/stores/useAuditCalendarStore/components/AuditCalendar.vue'
</script>

<template>
  <div class="audit-chart">
    <AuditCalendar />
  </div>
</template>

<style  lang="scss">
@use "@core/scss/template/libs/full-calendar";

.audit-chart {
  .fc {
    --fc-border-color: rgba(var(--v-border-color), var(--v-border-opacity));
    --fc-page-bg-color: rgb(var(--v-theme-surface));

    .fc-timeline-header-row {
      text-transform: capitalize;
    }

    .fc-resource-area {
      background-color: rgb(var(--v-theme-background));
    }

    .fc-datagrid-cell-main {
      font-size: 0.875rem;
      white-space: normal;
      overflow-wrap: anywhere;
    }

    .fc-timeline-header,
    .fc-scrollgrid-section-header {
      position: sticky;
      top: 0;
      z-index: 10;
      background: rgb(var(--v-theme-surface));
    }

    @media (max-width: 599.98px) {
      .fc-resourceTimelineYear-view .fc-event-main {
        display: flex;
        align-items: center;
        justify-content: center;
        inline-size: 100%;
        text-align: center;
      }
    }
  }
}
</style>
